import { TemplatePreviewPayload } from "interfaces";

export function GetTemplatePreview(this: any): TemplatePreviewPayload {
  const adapterData = this.adapterIds.map((adapterId: number) => {
    return { adapterId, itemId: this.caseNo };
  });
  const payload = {
    templateId: this.templateId,
    adapterData: adapterData,
    dataItem: this.caseNo,
  };

  return payload;
}
